export function getAuthenticityToken(): string {
  return (
    document
      ?.querySelector('meta[name="csrf-token"]')
      ?.getAttribute('content') || ''
  )
}
